import React from "react";
import PropTypes from "prop-types";
import Select from "react-select";

import ClipboardCopy from "@components/common/clipboard_copy/main";
import AttachmentSidebar from '../shared/attachment_sidebar/main';
import VisibleAttachment from "../shared/visible_attachment/main";

import "./styles/main";


class AssetEmbed extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      attachments: [],
      visibleAttachment: null,
      selectedFormat: {},
      selectedWidth: '',
      selectedHeight: '',
      loading: true
    };

    this.activeRequests = [];
  }

  /* NOTE :: When you have a parent modal component that grabs the asset info
  you won't need to grab the attachments on each tab, you can grab them when
  you load the modal and then just pass them down. */
  componentDidMount() {
    const attachmentsRequest = $.ajax({
      context: this,
      type: "GET",
      url: `/api/v4/assets/${this.props.assetKey}/attachments?fields=best_metadata,other_metadata,download_url,thumbnail_url,view_thumbnail_retina,extension,thumbnailed,conversion_options`,
      beforeSend: (xhr) => {
        xhr.setRequestHeader("Authorization", `Bearer ${BF_Token}`);
      },
      success: (response) => {
        const sortedAttachments = response.data.sort((a, b) => (
          a.attributes.position > b.attributes.position ? 1 : -1
        ));
        const firstAttachment = sortedAttachments[0];
        const fileFormat = firstAttachment.attributes.extension || '';

        this.setState({
          attachments: sortedAttachments,
          loading: false,
          visibleAttachment: firstAttachment,
          selectedFormat: { value: fileFormat, label: fileFormat.toUpperCase() },
          selectedWidth: firstAttachment.attributes.width || 0,
          selectedHeight: firstAttachment.attributes.height || 0
        });
      },
      error: () => {
        // TODO Create error state
        this.setState({ loading: false });
      }
    });
    this.activeRequests.push(attachmentsRequest);
  }

  componentWillUnmount() {
    this.activeRequests.forEach((request) => request.abort());
  }

  get iframe() {
    if (!this.state.visibleAttachment) { return null; }

    return `<iframe src='https://brandfolder.com/${this.props.brandfolderSlug}/attachments/embed/${this.state.visibleAttachment.id}?resource_type=Brandfolder&frame=auto&animated=false&loop=false&muted=false&autoplay=false' frameborder='0' allowfullscreen></iframe>`;
  }

  get formatOptions() {
    if (!this.state.visibleAttachment) { return null; }

    const formatOptions = [
      { value: "jpg", label: "JPG" },
      { value: "png", label: "PNG" },
      { value: "pdf", label: "PDF" },
      { value: "gif", label: "GIF" },
      { value: "svg", label: "SVG" }
    ];
    const visibileExtension = this.state.visibleAttachment.attributes.extension;

    if (!formatOptions.find((option) => option.value === visibileExtension)) {
      formatOptions.push({
        value: visibileExtension,
        label: visibileExtension.toUpperCase(),
      });
    }
    return formatOptions;
  }

  stripExtensionFromName = (attachmentExtension, attachmentName) => {
    const extensionFromName = attachmentName.split('.').pop();
    // strip file extension from filename
    if (attachmentExtension && attachmentExtension.toLowerCase() === extensionFromName.toLowerCase()) {
      const attachmentNameUpdated = attachmentName.split('.');
      attachmentNameUpdated.pop();
      return attachmentNameUpdated.join('.');
    }
    return attachmentName;
  }

  link = () => {
    if (!this.state.visibleAttachment) { return null; }

    const { assetKey, assetName, cdnKey } = this.props;
    const { selectedFormat, selectedHeight, selectedWidth, visibleAttachment } = this.state;
    const {
      extension: attachmentExtension,
      filename: attachmentName,
      height,
      position,
      width,
    } = visibleAttachment.attributes;

    const attachmentNameStripped = this.stripExtensionFromName(attachmentExtension, attachmentName);
    const assetNameClean = assetName.replace(/ /g, "_").replace(/[^-a-zA-Z0-9_ ]+/gi, '');
    const attachmentNameClean = attachmentNameStripped.replace(/ /g, "_").replace(/[^-a-zA-Z0-9_ ]+/gi, '');
    const attachmentExtensionClean = attachmentExtension || '';
    const attachmentExtensionSelected = selectedFormat.value ? selectedFormat.value : attachmentExtensionClean;

    const assetRootLink = `${BFG.smartCDNRoot}/${cdnKey}/as/${assetKey}/${encodeURI(assetNameClean)}.${attachmentExtensionSelected}`;
    const attachmentRootLink = `${BFG.smartCDNRoot}/${cdnKey}/at/${visibleAttachment.id}/${encodeURI(attachmentNameClean)}.${attachmentExtensionSelected}`;
    let path = '';
    let pathPosition = '';

    if (selectedWidth !== width && selectedWidth !== '') {
      path += `?width=${selectedWidth}`;
    }

    if (selectedHeight !== height && selectedHeight !== '') {
      path += `${path.includes('?') ? '&' : '?'}height=${selectedHeight}`;
    }

    if (position > 0) {
      pathPosition = `${path.includes('?') ? '&' : '?'}position=${position + 1}`;
    }

    return {
      assetLink: `${assetRootLink}${path}${pathPosition}`,
      attachmentLink: `${attachmentRootLink}${path}`,
    };
  }

  maintainImageSizeRatio = (e) => {
    let { height, width } = this.state.visibleAttachment.attributes;
    const updatedValue = parseInt(e.target.value, 10);
    const aspectRatio = width / height;
    const isWidth = e.target.className && e.target.className.indexOf("asset-width") > -1;

    if (!Number.isInteger(updatedValue)) {
      width = '';
      height = '';
    } else if (isWidth) {
      width = updatedValue;
      height = Math.round(width / aspectRatio);
    } else {
      height = updatedValue;
      width = Math.round(height * aspectRatio);
    }

    this.setState({ selectedWidth: width, selectedHeight: height });
  }

  updateActiveImage = ({ id: attachmentId }) => {
    if (attachmentId !== this.state.visibleAttachment.id) {
      this.setState((prevState) => {
        const visible = prevState.attachments.find((attachment) => attachment.id === attachmentId);
        return {
          visibleAttachment: visible,
          selectedFormat: { value: visible.attributes.extension, label: visible.attributes.extension.toUpperCase() },
          selectedWidth: visible.attributes.width || 0,
          selectedHeight: visible.attributes.height || 0,
        };
      });
    }
  }

  render() {
    const { attachments, loading, visibleAttachment } = this.state;
    const isVideo = visibleAttachment && visibleAttachment.attributes && visibleAttachment.attributes.mimetype && visibleAttachment.attributes.mimetype.indexOf("video") > -1;
    const activeCard = visibleAttachment
      ? { id: visibleAttachment.id, type: 'attachment' }
      : null;

    return (
      <div className="flex-wrapper asset-embed-component">
        <AttachmentSidebar
          attachments={attachments.length ? attachments : null}
          updateActiveCard={this.updateActiveImage}
          activeCard={activeCard}
        />
        {loading ? (
          <div className="flex-two-thirds no-similar-details loader-container">
            <video
              className="brandfolder-loader"
              width="90"
              height="90"
              poster="https://cdn.brandfolder.io/4OQZ5PW1/as/pxmju5-qfr48-21nt37/generic-loader.gif"
            />
          </div>
        ) : (
          <div className="flex-two-thirds embed-details">
            {visibleAttachment && visibleAttachment.attributes ? (
              <React.Fragment>
                <VisibleAttachment
                  extension={visibleAttachment.attributes.extension}
                  filename={visibleAttachment.attributes.filename}
                  height={visibleAttachment.attributes.height}
                  size={visibleAttachment.attributes.size}
                  thumbnail={visibleAttachment.attributes.thumbnail_url}
                  width={visibleAttachment.attributes.width}
                />
                <div className="embed-text">
                  <h3> {t('Embed this asset')} </h3>
                  <p>{t('By embedding this link you are acknowledging that it is accessible to anyone from where it is embedded.')}</p>
                </div>
                <hr />
                {isVideo ? (
                  <div className="cdn-builder">
                    <div className="copy-link-container">
                      <h3>{t('Video Embed Code ')}</h3>
                      <ClipboardCopy
                        textToCopy={this.iframe}
                        check
                        showFeedbackAsTooltip={false}
                      >
                        <span className="bff-copy" />{t(' Copy to clipboard')}
                      </ClipboardCopy>
                    </div>
                    <pre className="embed-link">
                      <code>
                        <span className="embed-link">{this.iframe} </span>
                      </code>
                    </pre>
                    <p>{('See our ')}
                      <a
                        href="https://help.brandfolder.com/hc/en-us/articles/360005174134-Embedding-Assets-with-Smart-CDN"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {t('CDN documentation')}
                      </a>
                    </p>
                  </div>
                ) : (
                  <div className="cdn-builder">
                    <div className="copy-link-container">
                      <div className="cdn-title">
                        <h3> {t('CDN Link - Asset')} </h3>
                      </div>
                      <ClipboardCopy
                        textToCopy={this.link().assetLink}
                        check
                        showFeedbackAsTooltip={false}
                      >
                        <span className="bff-copy" /> {t('Copy to clipboard')}
                      </ClipboardCopy>
                    </div>
                    <pre className="embed-link">
                      <code>
                        <span className="embed-link">{this.link().assetLink} </span>
                      </code>
                    </pre>
                    <div className="copy-link-container">
                      <div className="cdn-title">
                        <h3> {t('CDN Link - Attachment')} </h3>
                      </div>
                      <ClipboardCopy
                        textToCopy={this.link().attachmentLink}
                        check
                        showFeedbackAsTooltip={false}
                      >
                        <span className="bff-copy" /> {t('Copy to clipboard')}
                      </ClipboardCopy>
                    </div>
                    <pre className="embed-link">
                      <code>
                        <span className="embed-link">{this.link().attachmentLink} </span>
                      </code>
                    </pre>
                    <div className="embed-input">
                      <div className="format-select">
                        <label> {t('Format')} </label>
                        <Select
                          value={this.state.selectedFormat}
                          options={this.formatOptions}
                          clearable={false}
                          searchable={false}
                          onChange={(selected) => this.setState({ selectedFormat: selected })}
                        />
                      </div>
                      <div className="resize-dimension-container">
                        <div className="width-input">
                          <label> {t('Width (px)')}</label>
                          <input
                            className="asset-width input"
                            value={this.state.selectedWidth}
                            onChange={this.maintainImageSizeRatio}
                          />
                        </div>
                        <span className="bff-private" />
                        <div className="height-input">
                          <label> {t('Height (px)')}</label>
                          <input
                            className="asset-height input"
                            value={this.state.selectedHeight}
                            onChange={this.maintainImageSizeRatio}
                          />
                        </div>
                      </div>
                    </div>
                    <p>{t('See our ')}
                      <a
                        href="https://help.brandfolder.com/hc/en-us/articles/360005174134-Embedding-Assets-with-Smart-CDN"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {t('CDN documentation')}
                      </a>
                    </p>
                  </div>
                )}
                <hr />
                <div className="api-link">
                  <div className="copy-link-container">
                    <h3> {t('API Usage')} </h3>
                  </div>
                  <p> {t('See our')}&nbsp;
                    <a
                      href="https://developers.brandfolder.com"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {t('API documentation')}
                    </a>
                  </p>
                </div>
              </React.Fragment>
            ) : ''}
          </div>
        )}
      </div>
    );
  }
}

AssetEmbed.propTypes = {
  assetKey: PropTypes.string.isRequired,
  assetName: PropTypes.string.isRequired,
  brandfolderSlug: PropTypes.string.isRequired,
  cdnKey: PropTypes.string.isRequired
};

export default AssetEmbed;
